@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.modalOverlay {
    background-color: rgb(0 0 0 / 70%);
}

.modalContent {
    height: fit-content;
    margin: 10vh 10vw;
    max-height: 80vh;
    max-width: 80vw;
    width: fit-content;

    & figure {
        height: 100%;
        width: 100%;

        & img {
            display: block;
            margin: 0 auto;
            max-height: 100%;
        }
    }
}

.modalImageContainer {
    position: relative;
    width: 100%;
}

.modalClose {
    margin: 10vh 10vw;
}

.doNotAskAgain {
    align-items: center;
    display: inline-flex;
    position: fixed;
    right: 5rem;
    z-index: 10;
    margin: 3vh 10vw;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        font-size: var(--checkbox-mobile-font-size, 16px);
    }
}
